import {
  Box,
  Divider,
  Flex,
  Heading,
  HStack,
  Icon,
  Spinner,
  Text,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import FilterBar from './components/FilterBar';
import Restaurants from './components/Restaurants';
import TitleResults from './components/TitleResults';
import SearchRestaurants from '../../common/components/SearchRestaurants';
import { FaLeaf } from 'react-icons/fa';
import useOffGrayColor from '../../common/hooks/useOffGrayColor';
import TopNavigation from '../../common/components/TopNavigation';
const Search = () => {
  const [loading, setLoading] = useState(false);
  const green = useColorModeValue('green.400', 'green.100');
  const { offGray } = useOffGrayColor();

  return (
    <VStack w="100%" align="flex-start" px={10}>
      <Box w="100%">
        <TopNavigation />
      </Box>
      {!loading ? (
        <>
          <VStack w="100%" align="flex-start" pb={10}>
            <VStack align="flex-start">
              <HStack align="center">
                <Heading size="2xl">
                  Safely eat in Rochester <Icon as={FaLeaf} color={green} />
                </Heading>
              </HStack>
              <Text color={offGray}>
                Find your next meal without worrying about what's inside. Find
                allergens or specific ingredients with our filter.
              </Text>
            </VStack>
            <SearchRestaurants setLoading={setLoading} />
          </VStack>
          <TitleResults />
          {/* <Divider /> */}
          <Restaurants />
        </>
      ) : (
        <Flex w="100%" h="100vh" justify="center" align="center">
          <Spinner size="xl" />
        </Flex>
      )}
    </VStack>
  );
};

export default Search;
